import React from "react";
import Markdown from "markdown-to-jsx";
import {useTranslate} from "../useTranslate";

function SafeLink({children, href, ...props}) {
    const safeHref = /^(https?:|mailto:|\/|#)/i.test(String(href || "")) ? href : undefined;
    return <a {...props} href={safeHref} target="_blank" rel="noreferrer noopener">{children}</a>;
}

function ResponsiveTable({children, ...props}) {
    return (
        <div className="overflow-x-auto my-2">
            <table {...props}>{children}</table>
        </div>
    );
}

export default function MarkdownHelp({contentKey, titleKey = "form-help-title"}) {
    const translate = useTranslate();
    const content = translate(contentKey);

    if (!content || content === contentKey) return null;

    return (
        <section className="surface-50 border-1 border-200 border-round-xl p-3 mt-3 rtl">
            <div className="flex align-items-center gap-2 mb-2 text-700">
                <i className="pi pi-book"/>
                <span className="font-bold text-sm">{translate(titleKey)}</span>
            </div>
            <Markdown
                className="text-xs line-height-3 text-700"
                options={{
                    disableParsingRawHTML: true,
                    forceWrapper: true,
                    wrapper: "div",
                    overrides: {
                        a: {component: SafeLink},
                        table: {component: ResponsiveTable},
                    },
                }}
            >
                {String(content)}
            </Markdown>
        </section>
    );
}
